import React, { useContext, useEffect, useState } from 'react';
import './filtersearch.css';
import { addcontext } from '../ContextShare/ContextShare';
import Select from "react-select";
import { useNavigate } from 'react-router-dom';
import { FilterSearch, GetAllMemberIdArray, GetAllMemberIdArrayWithSession, GetEventListForSearchFilter, GetInitialDate, GetKlaListForSearchFilter, GetSessionListForSearchFilter, GetSessionListForSearchFilterWithKla } from '../Services/allApi';
import { toast } from 'react-toastify';
import language from '../language.json'
import { Icon } from '@iconify/react/dist/iconify.js';

function Filtersearch({ selectedSession, setSelectedSession, selectedKLA, setSelectedKLA, selectedEvent, setSelectedEvent, selectedMember, setSelectedMember, selectedFromDate, setselectedFromDate, selectedToDate, setselectedToDate }) {
  const [searchFilterData, setsearchFilterData] = useState({
    kla_id: '', session_id: '', member_id: '', event_id: '', start_date: '', end_date: ''
  });
  const {isSearchOrAdSearch,setIsSearchOrAdSearch}=useContext(addcontext)
  const {paginationStartIndex,setPaginationStartIndex}=useContext(addcontext)
    const {paginationEndIndex,setPaginationEndIndex}=useContext(addcontext)
  const{totalSearchResults,seTtotalSearchResults}=useContext(addcontext)
  const {filterSearchResults,setFilterSearchResults} = useContext(addcontext);
  const {searchError,setSearchError}=useContext(addcontext)
  const [klaList, setKlaList] = useState([]);
  const [sessionList, setSessionList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const { InitialSearchQuery, setInitialSearchQuery } = useContext(addcontext);
  const [selectedOptionKla, setSelectedOptionKla] = useState(null);
  const [selectedOptionSession, setSelectedOptionSession] = useState(null);
  const [selectedOptionEvents, setselectedOptionEvents] = useState(null);
  const [selectedOptionMember, setselectedOptionMember] = useState(null);
  const navigate = useNavigate();
  const {langChanged,setlangChanged}=useContext(addcontext)

  const [currentLanguage, setCurrentLanguage] = useState();
  const [buttonClickedLoding,setButtonClickedLoding]=useState(false)
  useEffect(()=>{
      setCurrentLanguage(localStorage.getItem('language')||'en')

},[currentLanguage,langChanged])
  // get kla list
  const klaListCallApi = async () => {
    try {
      const result = await GetKlaListForSearchFilter();
      setKlaList(result?.data?.data);
    } catch (error) {
      console.error("Error fetching Kla list for filter:", error);
    }
  };

  useEffect(() => {
    klaListCallApi();
  }, []);

  const klaoptions = klaList?.map((item) => ({
    value: item.kla_no,
    label: `${language.kla[currentLanguage]}${item.kla_no}`,
    valuefrosearch: item.kla_id
  }));

  // get session list
  const SessionListCallApi = async () => {
    var resultSession;
    try {
      if (selectedOptionKla != null) {
        const kla = selectedOptionKla.valuefrosearch;
        resultSession = await GetSessionListForSearchFilterWithKla(kla);
      } else {
        resultSession = await GetSessionListForSearchFilter();
      }
      setSessionList(resultSession?.data?.data);
    } catch (error) {
      console.error("Error fetching Session list for filter:", error);
    }
  };

  useEffect(() => {
    SessionListCallApi();
  }, [selectedOptionKla]);

  const sessionoptions = sessionList?.map((item) => ({
    value: item.session_no,
    label: `${language.Session[currentLanguage]}${item.session_no}`,
    valuefrosearch: item.session_id
  }));

  // get event list
  const EventListCallApi = async () => {
    try {
      const resultEvent = await GetEventListForSearchFilter();
      setEventList(resultEvent?.data?.data);
    } catch (error) {
      console.error("Error fetching Event list for filter:", error);
    }
  };

  useEffect(() => {
    EventListCallApi();
  }, []);

  const eventoptions = eventList?.map((item) => ({
    value: item.event_name,
    label: currentLanguage=='en'?item?.event_name:item?.mal_event_name,
    valuefrosearch: item.event_id
  }));

  // get Member list
  const MemberListCallApi = async () => {
    var memberPayload
    
    if(selectedOptionKla?.valuefrosearch&&selectedOptionSession?.valuefrosearch){
      memberPayload={kla_id:selectedOptionKla?.valuefrosearch,session_id:selectedOptionSession?.valuefrosearch}
    }
    else if(selectedOptionKla?.valuefrosearch){
      memberPayload={kla_id:selectedOptionKla?.valuefrosearch}
    }
    else if(selectedOptionSession?.valuefrosearch){
      memberPayload={session_id:selectedOptionSession?.valuefrosearch}
    }
    try {
      const resultMember = memberPayload ? await GetAllMemberIdArrayWithSession(memberPayload) : await GetAllMemberIdArray();
      setMemberList(resultMember?.data);
    } catch (error) {
      console.error("Error fetching Member list for filter:", error);
    }
  };

  useEffect(() => {
    MemberListCallApi();
  }, [selectedOptionSession,selectedOptionKla]);

  const memberoptions = memberList?.map((item) => ({
    value: item.member,
    label: currentLanguage=='en'?item.member:item?.malayalam_member_name,
    valuefrosearch: item.id
  }));

  // get date when session selected
  const getinitialdateapi = async () => {
    try {
      if (selectedOptionSession != null) {
        const resultdate = await GetInitialDate(selectedOptionSession.valuefrosearch);
        // setselectedFromDate(resultdate.data[0].session_start_date);
        // setselectedToDate(resultdate.data[0].session_end_date);
      }
    } catch (error) {
      console.error("Error fetching date list for filter:", error);
    }
  };

  useEffect(() => {
    getinitialdateapi();
  }, [selectedOptionSession]);

  const handlechange = (selectedOptionKla) => {
    setSelectedOptionKla(selectedOptionKla);
    setSelectedOptionSession(null);
    setselectedOptionMember(null);
  };

  const handlechangesession = (selectedOptionSession) => {
    setSelectedOptionSession(selectedOptionSession);
    setselectedOptionMember(null);
  };

  const handlechangeevents = (selectedOptionEvents) => {
    setselectedOptionEvents(selectedOptionEvents);
  };

  const handlechangemembers = (selectedOptionMember) => {
    setselectedOptionMember(selectedOptionMember);
  };

  const { isFilterOpen, setFilterOpen } = useContext(addcontext);

  const handleMouseLeaveFilter = (e) => {
    e.preventDefault();
    var fromDateInput = document.getElementById("fromdate");
    var toDateInput = document.getElementById("todate");

    if (document.activeElement === fromDateInput || document.activeElement === toDateInput) {
      setFilterOpen(true);
    } else {
      setFilterOpen(false);
    }
  };

  const handleSearchButtonClick = (e) => {
    try {
      e.preventDefault();
      const searchData = {
        kla_id: selectedOptionKla?.valuefrosearch,
        session_id: selectedOptionSession?.valuefrosearch,
        member_id: selectedOptionMember?.valuefrosearch,
        event_id: selectedOptionEvents?.valuefrosearch,
        start_date: selectedFromDate !== "" && selectedFromDate !== null ? selectedFromDate : undefined,
        end_date: selectedToDate !=="" && selectedToDate !== null ? selectedToDate : undefined,
      };
      if(searchData.kla_id||searchData.session_id||searchData.member_id||searchData.event_id||searchData.start_date||searchData.end_date){
        console.log(searchData);
        setButtonClickedLoding(true)
        searchsubmitapi(searchData)}
        else{
          toast.warning("Please select an option to search")
        }
    } catch {
      alert("Not found");
    }
  };

  const searchsubmitapi = async (searchData) => {
    try {
      const resultSearch = await FilterSearch(searchData, 1, 10);
      console.log(resultSearch);
      setInitialSearchQuery(searchData);
      setFilterSearchResults(resultSearch.data?.data);
      setSearchError(resultSearch?.response?.data?.message)
      seTtotalSearchResults(resultSearch?.data?.count)
      setIsSearchOrAdSearch('as')
      setPaginationStartIndex(1)
      setPaginationEndIndex(10)
      navigate('/results');
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className='flex w-full h-full justify-center text-white'>
      <div className={`flex flex-col bg-white lg:w-3/6 md:w-5/6 w-full p-4 ${currentLanguage !='en' &&'text-xs'} `} style={{ borderRadius: '10px', height: '100%' }}>
        {/* select KLA */}
        {/* <div className='flex justify-end items-star text-red-500'>
          <div className='w-8 h-8 bg-success rounded-full flex items-center justify-center'><Icon icon="iconamoon:close" /></div>
        </div> */}
        <div className='flex flex-row mt-5 w-full justify-between text-black'>
          <div className='w-4/12'><h3>{language.Select_kla[currentLanguage]}</h3></div>
          <div className='flex w-7/12'>
            <Select
              className='w-full'
              placeholder={language.Select_option[currentLanguage]}
              options={klaoptions}
              value={selectedOptionKla}
              onChange={handlechange}
            />
          </div>
        </div>

        {/* select session */}
        <div className='flex flex-row mt-10 w-full justify-between text-black'>
          <div className='w-4/12'><h3>{language.Select_session[currentLanguage]}</h3></div>
          <div className='flex w-7/12'>
            <Select
            placeholder={language.Select_option[currentLanguage]}
              className='w-full'
              options={sessionoptions}
              value={selectedOptionSession}
              onChange={handlechangesession}
              // placeholder='Current session'
            />
          </div>
        </div>

        {/* select Events */}
        <div className='flex flex-row mt-10 w-full justify-between text-black'>
          <div className='w-4/12'><h3>{language.Select_event[currentLanguage]}</h3></div>
          <div className='flex w-7/12'>
            <Select
            placeholder={language.Select_option[currentLanguage]}
              className='w-full'
              options={eventoptions}
              value={selectedOptionEvents}
              onChange={handlechangeevents}
            />
          </div>
        </div>

        {/* select Members */}
        <div className='flex flex-row mt-10 w-full justify-between text-black'>
          <div className='w-4/12'><h3>{language.Select_members[currentLanguage]}</h3></div>
          <div className='flex w-7/12'>
            <Select
              className='w-full'
              placeholder={language.Select_option[currentLanguage]}
              options={memberoptions}
              value={selectedOptionMember}
              onChange={handlechangemembers}
            />
          </div>
        </div>

        {/* select Date */}
        <div className='flex flex-row mt-10 w-full justify-between text-black'>
          <div className='w-4/12'><h3>{language.Select_date[currentLanguage]}</h3></div>
          <div className='flex flex-col md:flex-row w-7/12'>
            <div className='flex flex-col md:w-6/12 w-full'>
              <label htmlFor="fromdate">{language.From[currentLanguage]}</label>
              <input id='fromdate' value={selectedFromDate} onChange={(e) => setselectedFromDate(e.target.value)} type="date" placeholder='Date from' className='w-full rounded h-10' style={{ border: '1px solid silver' }} />
            </div>
            <div className='flex flex-col md:w-6/12 w-full mt-4 md:mt-0'>
              <label htmlFor="todate">{language.To[currentLanguage]}</label>
              <input type="date" id='todate' value={selectedToDate} onChange={(e) => setselectedToDate(e.target.value)} placeholder='Date to' className='w-full rounded h-10' style={{ border: '1px solid silver' }} />
            </div>
          </div>
        </div>

        {/* search button */}
        <div className='flex flex-row justify-center sm:mt-12 mt-8 mb-8 text-white w-full'>
          {!buttonClickedLoding?
          <button className='w-1/3 h-10 me-2 bg-primary hover:scale-105' style={{ borderRadius: '44px'}} onClick={handleSearchButtonClick}>{language.Search[currentLanguage]}</button>
          :
          <button className='flex flex-row justify-center items-center gap-2 w-1/3 h-10 me-2 bg-white border border-blue-500' style={{ borderRadius: '44px'}}
          ><div className="loader"></div><span className='text-blue-900'>Loading...</span></button>
        }
          <button className='w-1/3 h-10 ms-2 hover:scale-105 border-blue-500 hover:border-none bg-gray-200 hover:bg-gray-500 hover:text-white transform duration-500 ease-in-out border text-black' style={{ borderRadius: '44px' }} onClick={() => setFilterOpen(false)}>{language.close[currentLanguage]}</button>
        </div>
      </div>
    </div>
  );
}

export default Filtersearch;
